import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

import { AuthType, ClientStartupConfigService } from '../shared-context/client-startup-config.service';
import { UrlBuilder } from '../utilities/url-builder.utility';
import { UrlParser } from '../utilities/url-parser.utility';

/**
 * Append auth parameter to urls
 */
@Injectable({
    providedIn: 'root'
})
export class UrlAuthenticatorService {

    private static readonly pvrQueryName = 'auth_pvr';
    private static readonly upnQueryName = 'auth_upn';

    private readonly authParams: string;

    constructor(
        clientStartupConfigService: ClientStartupConfigService
    ) {
        const userPrincipalName = clientStartupConfigService.config.userPrincipalName;
        const authType = clientStartupConfigService.config.authType;

        if (userPrincipalName && authType !== AuthType.Unknown) {
            const params: Params = {};
            params[UrlAuthenticatorService.pvrQueryName] = (authType === AuthType.OrgId) ? 'OrgId' : 'WindowsLiveId';
            params[UrlAuthenticatorService.upnQueryName] = userPrincipalName;
            this.authParams = UrlBuilder.buildQueryPath(params);
        }
    }

    public appendPvrAndUpnAuthParams(url: string) {
        if (!url || !this.authParams) {
            return url;
        }

        const location = UrlParser.getLocation(url);
        const params = UrlParser.getQueryParams(location.search);
        if (params[UrlAuthenticatorService.pvrQueryName] || params[UrlAuthenticatorService.upnQueryName]) {
            return url;
        }

        return UrlBuilder.appendQuery(url, this.authParams);
    }
}
